// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"83":"86f1ff59","393":"eede7eb9","934":"43fb8455","985":"4e59c319"}[chunkId] + ".chunk.js";
};